import { axiosInstance } from "../axios";

/**
 * Saves the focal point a member chose on one of their own images — MemberMediaApiController.
 *
 * `source` says what kind of image it is, which decides the server's ownership check:
 * "cover" | "avatar" | "story" | "project" | "video" | "collection". A collection image is addressed
 * by the collection's `id` (with its `mediaKey` when known); everything else by `mediaKey`.
 *
 * Answers { isSuccess, left, top, message } and never throws: a refusal carries the server's own
 * member-facing wording.
 */
export const postFocalPoint = async ({ source, id = null, mediaKey = null, left, top }) => {
  try {
    const response = await axiosInstance.post("/api/member-media/focal-point", {
      source,
      id,
      mediaKey,
      left,
      top,
    });

    return {
      isSuccess: Boolean(response.data?.isSuccess),
      left: response.data?.left ?? left,
      top: response.data?.top ?? top,
      message: null,
    };
  } catch (error) {
    return {
      isSuccess: false,
      left,
      top,
      message:
        error?.response?.data?.message ??
        "Sorry, the framing could not be saved just now. Please try again shortly.",
    };
  }
};
